const reviewListDisplay = () => ({
    loading: true,
    init() {
        const reviewObserver = new MutationObserver(() => {
            if (document.querySelector('[data-bv-ready="true"]')) {
                this.loading = false
                reviewObserver.disconnect()
            }
        })

        const reviewContainer = document.querySelector('[data-bv-show="reviews"]')

        // just in case this js somehow runs after the reviews are already loaded, as the observer won't fire
        if (reviewContainer.textContent) {
            this.loading = false
        } else {
            reviewObserver.observe(reviewContainer, {
                childList: true,
                subtree: true,
                attributes: true
            })
        }
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('reviewListDisplay', reviewListDisplay)
})
